// extracted by mini-css-extract-plugin
export var orderSummary = "_t0-0";
export var showMoreLessButton = "_t0-1";